import { combineReducers } from 'redux'
import reducer from './privateReducer';

const createReducer = (history, injectedReducers) => combineReducers({
    private: reducer,
    ...injectedReducers
})

export default createReducer;